export default __webpack_public_path__ + "static/media/flag-turkey.ea9c17e6.svg";